import { useMediaQuery } from '@material-ui/core'
import Card from 'components/Card/Card'
import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem'
import { getPublicUserByHandle } from 'controllers/CoreServiceController'
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/material-kit-react/views/profilePage.js'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logWithTime } from 'util/screenUtils'
import Studio from 'vortex/Studio'
import Footer from 'components/Footer/Footer'
import HarmonizeHeader from 'components/Header/HarmonizeHeader'
import { setMessages } from 'redux/actions/messagesActions'
import { setPlayList } from 'redux/actions/messagesActions'
import harmony from '../../images/harmony.jpg'
import { setCurrentArtist } from 'redux/actions/artistActions'

const useStyles = makeStyles(styles)

export default function VortexSwitch() {
    const { currentArtist } = useSelector((state) => state.artist)
    const { handle } = currentArtist
    console.log(`\n*** VortexSwitch currentArtist`, currentArtist)
    const [user, setUser] = useState(null)
    const [invalidUser, setInvalidUser] = useState(false)
    const narrow = useMediaQuery('(max-width:400px)')
    const classes = useStyles()
    const dispatch = useDispatch()

    const displayLoading = () => {
        console.log(`VortexSwitch displayLoading `)
        return (
            <div>
                <div style={{
                    backgroundSize: 'contain',
                    backgroundImage: `url(${harmony})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    opacity: 1

                }} />

            </div>
        )
    }
    const noSuchUser = () => {
        return (<div >
            <div style={{
                height: narrow ? '200vh' : '100vw'
            }}>
                <HarmonizeHeader />
                <div className={classes.container}>
                    <GridContainer style={{ justifyContent: 'center' }}>
                        <GridItem xs={12} sm={12} md={8}>
                            <Card >
                                There is no user {handle}
                            </Card>

                        </GridItem>
                    </GridContainer>
                </div>
                <Footer position={'fixed'} />
            </div>

        </div>)
    }
    useEffect(() => {
        console.log('VortexSwitch useEffect')
        const getArtist = async () => {
            try {
                const publicUser = await getPublicUserByHandle(handle)
                console.log('publicUser', publicUser)
                if (publicUser.status !== 200) {
                    setUser(null)
                    setInvalidUser(true)
                } else {
                    /*
                    const { rooms, defaultRoomName } = publicUser
                    if (rooms && defaultRoomName) {
                        const gotoRoom = rooms.find(r => r.name === defaultRoomName)
                        console.log(`...VortexSwitch defaultRoomName ${defaultRoomName}`, gotoRoom)
                        dispatch(setCurrentArtist({ ...currentArtist, defaultRoomName }))
                    }
                    */
                    setUser(publicUser)
                }
            } catch (error) {
                console.error(`Unable to get public user ${handle}`, error)
            }
        }

        if (!user) {
            getArtist()
        }
        dispatch(setMessages([]))
        dispatch(setPlayList([]))
        console.log('VortexSwitch clear messages and playlist')
    }, [])

    if (invalidUser) {
        return noSuchUser()
    } else if (user) {

        return <Studio />

    } else {
        logWithTime('VortexSwitch no user yet')
        return displayLoading()
    }
}